<template>
    <div class="search-container">
        <input type="text" :placeholder="$t('search')" class="search-input" v-model="internalSearchText"
            @keyup.enter="triggerSearch" />
        <span v-if="internalSearchText" class="clear-icon" @click="triggerClear">
            &times;
        </span>
        <span class="search-icon" style="cursor: pointer;" @click="triggerSearch">
            <i class="fas fa-search"></i>
        </span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SearchComponent',
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue', 'search', 'clear'],
    data() {
        return {
            internalSearchText: this.modelValue
        };
    },
    watch: {
        modelValue(newVal: string) {
            if (this.internalSearchText !== newVal) {
                this.internalSearchText = newVal;
            }
        },
        internalSearchText(newVal: string) {
            this.$emit('update:modelValue', newVal);
        }
    },
    methods: {
        triggerSearch() {
            this.$emit('search', this.internalSearchText);
        },
        triggerClear() {
            this.internalSearchText = '';
            this.$emit('clear');
        }
    }
});
</script>
